<template>
  <div class="h-full">
    <VBusHelper
      :emitOnMounted="$constants.EVENTS.TRANSACTIONS.LATEST.REFRESH"
    />
    <TransactionsLoadingError
      v-if="$stores.transactions?.state?.latest?.error"
      @refresh="() => $bus.emit($constants.EVENTS.TRANSACTIONS.LATEST.REFRESH)"
    >
      <template #errorDescription>
        {{ $stores.transactions?.state?.latest?.error }}
      </template>
    </TransactionsLoadingError>
    <div
      v-else-if="$stores.transactions?.state?.latest?.list.length"
      class="space-y-4"
    >
      <TransactionItem
        @click="$bus.emit($constants.EVENTS.TRANSACTIONS.DETAIL.SHOW, trx)"
        v-for="trx in $stores.transactions?.state?.latest?.list"
        :item="trx"
      />
    </div>
    <div
      v-else-if="$stores.transactions?.state?.latest?.loading"
      class="space-y-4 shimmerContainer"
    >
      <TransactionItem v-for="trx in 3" :item="trx" />
    </div>
    <EmptyTransactions
      v-else
      @refresh="() => $bus.emit($constants.EVENTS.TRANSACTIONS.LATEST.REFRESH)"
    />
  </div>
</template>
